import React from "react";
import authImage from "../../assets/images/auth-image.png";
import SectionHeader from "../../components/ui/HeaderSection";
import PlainNavbar from "../../components/layout/PlainNavbar";
import InputField from "../../components/ui/InputField";
import Button from "../../components/ui/Button";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const navigate = useNavigate(); // Add this hook

  const handleOTPSubmit = () => {
    // Add any validation logic here if needed
    navigate("/reset-password");
  };
  return (
    <>
      <PlainNavbar />
      <div className="flex min-h-screen">
        {/* Gambar di sebelah kiri */}
        <div className="w-2/3 hidden lg:block overflow-hidden h-screen">
          <img
            src={authImage}
            alt="Auth"
            className="w-full h-screen object-cover object-left-top"
          />
        </div>

        {/* Form Login */}
        <div className="w-full lg:w-1/2 flex flex-col justify-start px-10 mt-10">
          {/* Header with left alignment */}
          <div className="text-left mt-20">
            <SectionHeader
              title="Silahkan Reset Password Anda"
              description="Masukkan detail akun Anda untuk melanjutkan"
              TitleColor="#010203"
              DescriptionColor="#ABABAB"
              textAlign="left"
            />
          </div>

          {/* Form */}
          <div className="mt-6 space-y-4">
            <InputField
              title="Email"
              placeholder="Masukkan email Anda"
              type="email"
            />
          </div>

          {/* Button Login */}
          <div className="mt-6 w-full">
            <Button
              text="Kirip OTP"
              fullWidth={true}
              className="w-full"
              onClick={handleOTPSubmit}
            />
          </div>

          {/* Back to Login */}
          <div
            className="flex items-center justify-center mt-6 text-gray-400 cursor-pointer hover:text-gray-600"
            onClick={() => window.history.back()}
          >
            <ArrowBackIcon className="mr-2" fontSize="small" />
            <span className="text-sm font-medium">Kembali Masuk</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
